/**
 * useAuth Hook — kombiniert OIDC-Session-State (Authentik via oidc-client-ts)
 * mit App-DB-Rollen vom Backend.
 *
 * - oidc-client-ts: Token, Session, signIn/signOut (siehe lib/oidc.ts)
 * - Backend /api/v1/auth/me: User-Profil, Rollen (RBAC), Tenant
 */

import { signIn, signOutHard, useOidcStore } from "@/lib/oidc"
import { useAuthStore } from "@/store/authStore"

export function useAuth() {
  const oidcUser = useOidcStore((s) => s.oidcUser)
  const oidcLoading = useOidcStore((s) => s.isLoading)
  const { user, isAuthenticated, isLoading, hasRole, hasPermission, isAdmin } = useAuthStore()

  const oidcAuth = Boolean(oidcUser && !oidcUser.expired)

  const login = () => {
    signIn()
  }

  const logout = async () => {
    try {
      await signOutHard()
    } catch {
      useAuthStore.getState().logout()
      window.location.href = "/login"
    }
  }

  return {
    // OIDC state (IdP-Session)
    oidcAuth,
    oidcLoading,
    // App state (from backend /api/v1/auth/me)
    user,
    isAuthenticated,
    isLoading,
    // Helpers
    hasRole,
    hasPermission,
    isAdmin,
    // Actions
    login,
    logout,
  }
}
